import { gql } from "@apollo/client";

const GET_ACCOUNTING_SYSTEMS = gql`
  query GetAccountingSystem {
    accountingSystems {
      data {
        accountingSystemName
        accountingSystemKey
        accountingSystemDisplayName
        accountingSystemShorthand
        creditMemoDocumentNumberPattern
        workflow {
          workflowId
          workflowKey
          workflowName
          workflowDescription
          isActive
          categorySplits {
            deductionTypeCategoryId
            deductionTypeCategoryKey
            deductionTypeCategoryName
            splitOrder
          }
        }
      }
    }
  }
`;

export default GET_ACCOUNTING_SYSTEMS;
